<template>
  <section class="renzh">
    <img src="../../assets/imgs/home/index-bg.png" alt="" />
    <div class="content flexc0c">
      <div class="title">欢迎来到中资云企业综合服务平台</div>
      <div class="sub-title">·矿产品行业服务综合解决方案·</div>
    </div>
  </section>
</template>
<script>
export default {
  name:"dealPlatform",
  data() {
    return {
      msg: "",
    };
  },
  methods: {},
};
</script>
<style scoped lang="less">
.renzh {
  width: 1000px;
  height: 880px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  position: relative;
  img {
    width: 814px;
    height: 562px;
    margin: 100px 80px;
  }
  .content {
    position: absolute;
    width: 100%;
    top: 220px;
    left: 0;
    .title {
      font-family: PingFangSC-Regular;
      font-size: 30px;
      color: #012f8d;
      letter-spacing: 0.56px;
      text-align: center;
    }
    .sub-title {
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #012f8d;
      letter-spacing: 20px;
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>
